import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/founder/voting-rights.webp")